import { render, staticRenderFns } from "./TypographySvg.vue?vue&type=template&id=1b068353&scoped=true&"
import script from "./TypographySvg.vue?vue&type=script&lang=js&"
export * from "./TypographySvg.vue?vue&type=script&lang=js&"
import style0 from "./TypographySvg.vue?vue&type=style&index=0&id=1b068353&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b068353",
  null
  
)

export default component.exports